import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';
import { motion } from 'framer-motion';

import type { MegaNavSection } from '../../types';
import { MobileMenuSectionHeader } from './MobileMenuSectionHeader';

interface MobileSubMenuSectionProps {
  section: MegaNavSection;
  parentName: string;
  navList?: any;
}

export const MobileSubMenuSection: React.FC<MobileSubMenuSectionProps> = ({
  section,
  parentName,
}) => {
  return (
    <Box>
      <MobileMenuSectionHeader label={section.title} />
      <Box display="flex" flexDirection="column">
        {section.links.map((link, linkIdx) => (
          <Box
            key={linkIdx}
            tag={motion.li as any}
            borderBottomWidth={linkIdx < section.links.length - 1 ? 1 : 0}
            borderColor="$borderPrimary"
          >
            <Link
              href={link.href}
              textDecorationLine="none"
              aria-label={`Navigate to ${link.name}`}
              analyticsName={`cosmos-mega-nav-mobile-${parentName.toLowerCase()}-${link.name
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
              paddingTop="$8x"
              paddingBottom="$8x"
              paddingLeft="$12x"
              paddingRight="$8x"
              display="flex"
            >
              <Text tag="span" typography="$bodyMedium" color="$contentPrimary">
                {link.name}
              </Text>
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
